import { useEffect } from "react";

const DigilockerCallback = () => {
  useEffect(() => {
    // Post to parent window
    console.log({ window }, window.opener);

    if (window.opener) {
      window.opener.postMessage("digilocker_complete", window.location.origin);
      // window.close(); // Close child tab
    }
  }, []);

  return (
    <>
      <h2 level={4}>Finalizing Aadhaar Verification…</h2>
      <p>You may close this tab manually if it doesn't close automatically.</p>
    </>
  );
};

export default DigilockerCallback;
